import React, { Component } from 'react'
import trans, { isTrans } from 'trans'
import { AxiosResponse } from "axios";
import _find from "lodash/find";

import {
    Icon,
    Button,
    Grid,
    GridCell,
    css,
    Theme,
} from '@bdfx/mergado-ui-kit'

import { CheckElementsType } from './check-elements-modal';
import { ReduxList } from 'app/types/app-types';
import { Template } from 'app/types/model-types';
import { connect } from 'react-redux';
import { applyAllSuggestedElementChanges, applySelectedElementChanges } from 'app/helpers/api';
import MergadoElementSelect from './mergado-element-select';


interface Props {
    templates: ReduxList<Template>
    suggestedChanges: CheckElementsType
    close: Function
    hideCheckElements: Function
}

interface State {
    applyChanges: CheckElementsType
}

class CheckElementsModalWrapper extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            applyChanges: { ...props.suggestedChanges },
        }
    }

    toggleShapeSelected = (idx: number) => {
        const { applyChanges } = this.state
        let updatedItems = [...applyChanges.shapes]
        updatedItems[idx].isSelected = !updatedItems[idx].isSelected
        this.setState({
            applyChanges: {
                ...applyChanges,
                shapes: updatedItems,
            }
        })
    }

    toggleProjectSelected = (idx: number) => {
        const { applyChanges } = this.state
        let updatedItems = [...applyChanges.project]
        updatedItems[idx].isSelected = !updatedItems[idx].isSelected
        this.setState({
            applyChanges: {
                ...applyChanges,
                project: updatedItems,
            }
        })
    }

    applySelectedOnly = (e) => {
        const { applyChanges } = this.state
        
        applySelectedElementChanges(applyChanges)
            .then((response: AxiosResponse<any>) => { })
            .catch((e) => console.error('cannot apply changes', e))
            .finally(() => this.props.close())
    }

    changeShapeNewValue = (idx: number, newValue?: string) => {
        const { applyChanges } = this.state
        let updatedItems = [...applyChanges.shapes]
        updatedItems[idx].newValue = newValue
        this.setState({
            applyChanges: {
                ...applyChanges,
                shapes: updatedItems,
            }
        })
    }

    changeProjectNewValue = (idx: number, newValue?: string) => {
        const { applyChanges } = this.state
        let updatedItems = [...applyChanges.project]
        updatedItems[idx].newValue = newValue
        this.setState({
            applyChanges: {
                ...applyChanges,
                project: updatedItems,
            }
        })
    }

    render() {
        const { templates } = this.props
        const { applyChanges } = this.state
        const iconSize = 22

        return (
            <div>
                <p>{trans('some_elements_not_available')}</p>

                <StyledGrid>
                    {applyChanges.project.length > 0 &&
                        applyChanges.project.map((e, idx: number) => {
                            const isSelected = e.isSelected
                            return <React.Fragment key={`project_element_${e.column}`}>
                                <GridCell className={'clickable'} onClick={() => this.toggleProjectSelected(idx)}>
                                    <Icon
                                        type={isSelected ? 'check-square-o' : 'square-o'}
                                        size={iconSize}
                                        color={isSelected ? Theme.blue : '#3e3e3e'}
                                    />
                                </GridCell>
                                <GridCell className={'clickable'} onClick={() => this.toggleProjectSelected(idx)}>
                                    {trans(e.column)}
                                </GridCell>
                                <GridCell className={'clickable'} onClick={() => this.toggleProjectSelected(idx)}>
                                    <code>{e.originalValue}</code>
                                </GridCell>
                                <GridCell style={{ textAlign: 'center' }}>
                                    <Icon type={'long-arrow-right'} />
                                </GridCell>
                                <GridCell>
                                    <MergadoElementSelect
                                        value={e.newValue}
                                        handleChange={(newValue) => this.changeProjectNewValue(idx, newValue)}
                                    />
                                </GridCell>
                            </React.Fragment>
                        })
                    }

                    {applyChanges.shapes.length > 0 &&
                        applyChanges.shapes.map((e, idx: number) => {
                            if (e) {
                                const isSelected = e.isSelected
                                const template = e.template_id ? _find(templates.data, (t: Template) => {
                                    return `${t.id}` === `${e.template_id}`
                                }) : null
                                return <React.Fragment key={`shape_element_${e.shape_id}_${e.template_id}`}>
                                    <GridCell className={'clickable'} onClick={() => this.toggleShapeSelected(idx)}>
                                        <Icon
                                            type={isSelected ? 'check-square-o' : 'square-o'}
                                            size={iconSize}
                                            color={isSelected ? Theme.blue : '#3e3e3e'}
                                        />
                                    </GridCell>
                                    <GridCell className={'clickable'} onClick={() => this.toggleShapeSelected(idx)}>
                                        <span title={`${trans('template')} ${e.template_id} ${trans('layer')} ${e.shape_id}, ${trans(e.type)}, ${isTrans(e.column) ? trans(e.column) : e.column}`}>{trans('template_layer')}</span> <b>{template && template.name}</b>
                                    </GridCell>
                                    <GridCell className={'clickable'} onClick={() => this.toggleShapeSelected(idx)}>
                                        <code style={{ background: '#ffffff', padding: '10px' }}>{e.originalValue}</code>
                                    </GridCell>
                                    <GridCell>
                                        <Icon type={'long-arrow-right'} />
                                    </GridCell>
                                    <GridCell>
                                        <MergadoElementSelect
                                            value={e.newValue}
                                            handleChange={(newValue) => this.changeShapeNewValue(idx, newValue)}
                                        />
                                    </GridCell>
                                </React.Fragment>
                            } else {
                                return <React.Fragment key={`ne_${idx}`}></React.Fragment>
                            }
                        })                    
                    }
                </StyledGrid>

                <Grid cols={'1fr 1fr'}>
                    <GridCell style={{ textAlign: 'left' }}></GridCell>
                    <GridCell style={{ textAlign: 'right' }}>
                        <Button key={'apply'} type={'void'} secondary={false} size={'small'} onClick={(e) => this.applySelectedOnly(e)}>
                            {trans('apply_only_selected_changes')}
                        </Button>
                    </GridCell>
                </Grid>
            </div>
        )
    }
}

const StyledGrid = css(Grid)({
    gridTemplateColumns: '30px auto max-content 30px minmax(200px, 1fr)',
    gridColumnGap: '20px',
    marginBottom: '20px',
    ' .muk-gridcell': {
        alignSelf: 'center'
    },
    ' .muk-form-group': {
        marginBottom: '0',
    },
})

function mapStateToProps(state) {
    return {
        templates: state.templates,
    }
}

export default connect(mapStateToProps, {
})(CheckElementsModalWrapper)

